// ----------------------------------------------------------------------

const MuiBackdrop = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    root: {
      backgroundColor: 'rgba(0, 0, 0, 0.6)'
    },
    invisible: { background: 'transparent' }
  }
}

// ----------------------------------------------------------------------

export const backdrop = { MuiBackdrop }
